import styled, { css } from "styled-components";
import {
  Tab as TabPrimitive,
  TabList as TabListPrimitive,
  TabPanel as TabPanelPrimitive,
} from "react-aria-components";
import { CoreButtonTabs } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

type TabListProps = {
  $variant: CoreButtonTabs.Variant;
};

export const TabList = styled(TabListPrimitive)<TabListProps>`
  ${({ $variant }) => {
    const { tokens } = useDesignTokens();
    const { buttonTabs } = tokens;

    return [
      css`
        display: flex;
        gap: ${buttonTabs.items.gap};
      `,
      $variant === "center" &&
        css`
          justify-content: center;
        `,
    ];
  }}
`;

type TabProps = {
  $fullWidth: boolean;
};

export const Tab = styled(TabPrimitive)<TabProps>`
  ${({ $fullWidth }) => {
    const { tokens } = useDesignTokens();
    const { buttonAlt } = tokens;

    return [
      css`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-width: ${buttonAlt.stroke.width.base};
        border-style: ${buttonAlt.stroke.style};
        border-color: ${buttonAlt.stroke.color.base};
        border-radius: ${buttonAlt.radius};
        min-width: ${buttonAlt.minWidth};
        min-height: ${buttonAlt.minHeight.md};
        padding-top: ${buttonAlt.padding.top};
        padding-left: ${buttonAlt.padding.left};
        padding-right: ${buttonAlt.padding.right};
        padding-bottom: ${buttonAlt.padding.bottom};
        color: ${buttonAlt.color.base};
        background: ${buttonAlt.backgroundColor.base};
        cursor: pointer;
        outline: none;

        &[data-focus-visible] {
          outline-width: ${buttonAlt.focusRing.width};
          outline-style: ${buttonAlt.focusRing.style};
          outline-color: ${buttonAlt.focusRing.color};
          outline-offset: ${buttonAlt.focusRing.offset};
        }

        &[data-hovered] {
          color: ${buttonAlt.color.hover};
          background: ${buttonAlt.backgroundColor.hover};
        }

        &[data-selected] {
          border-color: ${buttonAlt.stroke.color.active};
          color: ${buttonAlt.color.active};
          background: ${buttonAlt.backgroundColor.active};

          &[data-hovered] {
            border-color: ${buttonAlt.stroke.color.active};
            color: ${buttonAlt.color.active};
            background: ${buttonAlt.backgroundColor.active};
          }
        }
      `,
      $fullWidth &&
        css`
          width: 100%;
        `,
    ];
  }}
`;

export const TabPanel = styled(TabPanelPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { buttonTabs } = tokens;

    return css`
      &[data-focus-visible] {
        outline-width: ${buttonTabs.panel.focusRing.width};
        outline-style: ${buttonTabs.panel.focusRing.style};
        outline-color: ${buttonTabs.panel.focusRing.color};
      }
    `;
  }}
`;
